import styled from "styled-components/macro";
import { Progress } from "@gcs/design-system/react";
import { ReactComponent as UploadDoc } from "../../../../../assets/images/habitacional/upload-doc.svg";
import { ReactComponent as SuccessCheck } from "../../../../../assets/images/habitacional/success-check.svg";

const SpaceBetween = "space-between";

export const FileInputContainer = styled.div(
  ({ theme, dragging, success, error }) => {
    let border = `1px dashed ${theme.color.line.medium}`;
    let background = "default";

    if (dragging) {
      background = "rgba(255,255,255,.8)";
      border = `4px dashed ${theme.color.line.medium}`;
    }

    if (success) {
      background = theme.color.brandPrimary.light;
      border = `1px solid ${theme.color.brandPrimary.light}`;
    }

    if (error) {
      background = "rgba(255,255,255,.8)";
      border = `1px solid ${theme.color.feedback.error}`;
    }

    return {
      background,
      border,

      display: "flex",
      flexDirection: "column",
      padding: "16px",
      alignItems: "left",
      boxSizing: "border-box",
      borderRadius: "8px",
      opacity: dragging ? "0.2" : 1,
      [theme.breakpoint.md()]: {
        padding: "20px",
        width: "500px",
        maxWidth: "100%",
      },

      svg: {
        color: theme.color.brandSecondary.medium,
      },
    };
  }
);

export const TitleContainer = styled.div(() => ({
  display: "flex",
  justifyContent: SpaceBetween,
}));

export const FileInputTitle = styled.h4(({ theme, error }) => ({
  color: error ? theme.color.feedback.error : theme.color.neutral["02"],
  fontSize: "18px",
  fontWeight: "bold",
  fontStyle: "normal",
  lineHeight: "160%",
  textAlign: "left",
  [theme.breakpoint.md()]: {
    fontSize: "20px",
  },
}));

export const FileInputSubTitleLight = styled.p(({ theme, success, error }) => {
  let color = theme.color.neutral["03"];

  if (success) {
    color = theme.color.neutral["08"];
  }

  if (error) {
    color = theme.color.neutral["03"];
  }

  return {
    color,

    fontSize: "18px",
    fontWeight: "500",
    fontStyle: "normal",
    lineHeight: "160%",
    textAlign: "left",
    margin: 0,
    [theme.breakpoint.md()]: {
      fontSize: "20px",
    },
  };
});

export const FileInputTitleLink = styled.a(({ theme, $shouldBeInFront }) => ({
  fontSize: "20px",
  color: theme.color.neutral["08"],
  fontWeight: "bold",
  marginTop: "0",
  fontStyle: "normal",
  lineHeight: "160%",
  textAlign: "left",
  overflowWrap: "anywhere",
  cursor: "pointer",
  display: "flex",
  gap: "10px",
  alignItems: "baseline",
  textDecoration: "underline",
  marginBottom: "12px",
  zIndex: $shouldBeInFront ? 50 : -1,

  svg: {
    color: theme.color.neutral["08"],
  },

  [theme.breakpoint.md()]: {
    margin: "0",
    marginBottom: "20px",
  },
}));

export const FileInputSubTitle = styled.p(({ theme }) => ({
  fontSize: "16px",
  color: "#7F9398",
  fontWeight: "bold",
  lineHeight: "150%",
  margin: "0 0 12px 0px",
  fontStyle: "normal",
  textAlign: "left",
  [theme.breakpoint.md()]: {
    margin: "0 0 12px 0px",
  },
}));

export const FileInputDetails = styled.p(({ theme }) => ({
  fontSize: "14px",
  color: theme.color.neutral["03"],
  fontStyle: "normal",
  lineHeight: "150%",
  fontWeight: "500",
  textAlign: "left",
  [theme.breakpoint.md()]: {
    marginBottom: "0",
  },
}));

export const ContainerRow = styled.div(({ $shouldBeInFront }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  marginBottom: "12px",
  zIndex: $shouldBeInFront ? 50 : -1,
}));

export const ContainerFlex = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  zIndex: -1,
  alignItems: "left",
  [theme.breakpoint.md()]: {
    flexDirection: "column",
  },
}));

export const ContainerColumn = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "left",
}));

export const ButtonText = styled.p(({ theme, error }) => ({
  fontSize: "16px",
  color: error ? theme.color.feedback.error : theme.color.brandSecondary.medium,
  marginTop: "5px",
  fontStyle: "normal",
  lineHeight: "19px",
  fontWeight: "500",
  textAlign: "left",
  paddingLeft: "5px",
}));

export const Bar = styled.p(({ theme }) => ({
  borderLeft: `1px solid ${theme.color.line.medium}`,
  height: "28px",
  margin: "0 5px",
  [theme.breakpoint.md()]: {
    margin: "0 16px",
  },
}));

export const FlexRow = styled.div(({ theme, success, error }) => {
  let color = "default";

  if (success) {
    color = theme.color.neutral["08"];
  }

  if (error) {
    color = "default";
  }

  return {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    margin: 0,

    "svg, p": {
      color,
    },
  };
});

export const ErrorMessage = styled.h6(({ theme }) => ({
  textAlign: "inherit",
  display: "flex",
  alignItems: "center",
  svg: {
    margin: "0 5px",
    width: "1rem",
  },
  color: theme.color.feedback.error,
  marginTop: 0,
  marginBottom: 0,
  fontSize: "14px",
  fontWeight: "500",
  lineHeight: "150%",
}));

export const StyledUploadDoc = styled(UploadDoc)(
  ({ theme, $shouldBeInFront }) => ({
    color: theme.color.brandSecondary.medium,
    display: "none",
    cursor: "pointer",
    [theme.breakpoint.md()]: {
      display: "block",
      zIndex: $shouldBeInFront ? 50 : -1,
    },
  })
);

export const StyledSuccessCircle = styled(SuccessCheck)(({ theme }) => ({
  zIndex: -1,
  width: "25px",
  [theme.breakpoint.md()]: {
    width: "40px",
  },
}));

export const StyledProgressBar = styled(Progress)(({ theme }) => ({
  margin: "24px 0",
  width: "80%",
  [theme.breakpoint.md()]: {
    margin: "36px 0 12px",
  },
}));

export const ModifyButtonsContainer = styled.div(
  ({ theme, $shouldBeInFront }) => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    zIndex: $shouldBeInFront ? 50 : -1,
    justifyContent: SpaceBetween,
    marginTop: "16px",
    [theme.breakpoint.md()]: {
      marginTop: "24px",
    },
  })
);

export const StyledMobileButtons = styled.div(
  ({ theme, $shouldBeInFront }) => ({
    justifyContent: SpaceBetween,
    display: "flex",
    zIndex: $shouldBeInFront ? 50 : -1,
    marginTop: "16px",
    [theme.breakpoint.md()]: {
      display: "none",
      margin: "0 5px",
    },
  })
);

export const StyledLink = styled.a(({ theme }) => ({
  display: "none",
  cursor: "pointer",
  color: theme.color.brandSecondary.medium,
  fontWeight: "500",
  fontSize: "16px",
  lineHeight: "150%",
  textDecoration: "underline",
  marginLeft: "15px",
  ":hover": {
    fontWeight: "bold",
  },
  [theme.breakpoint.md()]: {
    display: "block",
  },
}));
